import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, Row, Col, Alert, InputGroup, InputGroupAddon, Input, FormFeedback, Button } from 'reactstrap'

class OffenceCreator extends Component {
    static propTypes = {
        createNewOffences: PropTypes.func,
        onUpdateList: PropTypes.func
    }

    constructor(props) {
        super(props)
        this.state = {
            code: '',
            description: '',
            alertColor: 'info',
            successAlertOpen: false,
            submitAlertMessage: '',
            codeInvalid: false,
            codeMsg: '',
            descInvalid: false,
            descMsg: ''
        }
    }

    onSubmitAlertDismiss = () => {
        this.setState({
            alertColor: 'info',
            successAlertOpen: false,
            submitAlertMessage: ''
        })
    }

    onNewOffenceSubmit = async () => {
        const { code, description } = this.state
        if (code === '') {
            this.setState({ codeInvalid: true, codeMsg: 'This field is required' })
            return
        }
        if (description === '') {
            this.setState({ descInvalid: true, descMsg: 'This field is required' })
            return
        }

        const { createNewOffences, onUpdateList } = this.props;

        try {
            await createNewOffences({ code: code, description: description });
            this.setState({
                alertColor: 'success',
                successAlertOpen: true,
                submitAlertMessage: 'New offence created'
            })
            onUpdateList()
        }
        catch (err) {
            if (err.name === 'code') {
                this.setState({
                    codeInvalid: true,
                    codeMsg: err.message
                })
            } else {
                this.setState({
                    alertColor: 'danger',
                    successAlertOpen: true,
                    submitAlertMessage: err.message
                })
            }
        }
    }

    render() {

        const {
            code,
            description,
            alertColor,
            successAlertOpen,
            submitAlertMessage
        } = this.state;

        return (
            <React.Fragment>
                <Form onSubmit={(e) => { e.preventDefault() }}>
                    <FormGroup>
                        <Row>
                            <Col xs="12">
                                <div className='text-center'>
                                    <Alert color={alertColor} isOpen={successAlertOpen} toggle={this.onSubmitAlertDismiss} className="mb-3">
                                        {submitAlertMessage}
                                    </Alert>
                                </div>
                            </Col>
                            <Col xs='12'>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Code :
                                    </InputGroupAddon>
                                    <Input
                                        invalid={this.state.codeInvalid}
                                        value={code}
                                        onChange={(e) => this.setState({ code: e.target.value })}
                                        onFocus={() => this.setState({ codeInvalid: false })}
                                    />
                                    <FormFeedback
                                        onClick={() => this.setState({ codeInvalid: false })}
                                        valid
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {this.state.codeMsg}
                                    </FormFeedback>
                                    <FormFeedback
                                        onClick={() => this.setState({ codeInvalid: false })}
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {this.state.codeMsg}
                                    </FormFeedback>
                                </InputGroup>
                            </Col>
                            <Col xs='12' className="mt-2">
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Description :
                                    </InputGroupAddon>
                                    <Input
                                        type='textarea'
                                        invalid={this.state.descInvalid}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                        onFocus={() => this.setState({ descInvalid: false })}
                                    />
                                    <FormFeedback
                                        onClick={() => this.setState({ descInvalid: false })}
                                        valid
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {this.state.descMsg}
                                    </FormFeedback>
                                    <FormFeedback
                                        onClick={() => this.setState({ descInvalid: false })}
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {this.state.descMsg}
                                    </FormFeedback>
                                </InputGroup>
                            </Col>
                            <Col xs='12' className="mt-2">
                                <div className='text-right'>
                                    <Button onClick={this.onNewOffenceSubmit} size='sm' color='primary' className="w-25">
                                        Submit
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
            </React.Fragment>
        )
    }
}

export default OffenceCreator



// WEBPACK FOOTER //
// ./src/components/features/OffenceCreator/OffenceCreator.js